import isEmpty from 'lodash.isempty';
import { METAFIELD_FILTER_PREFIX } from 'domains/Orders/constants';
import {
  FiltersType,
  PIPE_SEPARATOR,
  COMMA_SEPARATOR,
  paymentProviderFilter,
} from './constants';
import { ORDERS_PER_PAGE } from '../pages/constants';

interface fetchOrdersPayloadInterface extends FiltersType {
  metafields: Record<string, string>[];
  variantIds: string[];
  couponIds: string[];
}

export function fetchOrderDigest(filtersParams: FiltersType) {
  let othersFilters: Partial<fetchOrdersPayloadInterface> = {};
  let metafieldsFilters = {};
  Object.entries(filtersParams).forEach(([key, value]) => {
    if (key.startsWith(METAFIELD_FILTER_PREFIX) && value !== '') {
      metafieldsFilters = {
        ...metafieldsFilters,
        [key.split(METAFIELD_FILTER_PREFIX)[1]]: value,
      };
      return;
    }
    if (key === 'products') {
      const variantIds = value ? value.toString().split(';') : [];
      if (!isEmpty(variantIds)) {
        othersFilters = {
          ...othersFilters,
          variantIds,
        };
      }
      return;
    }
    if (key === 'couponIdsRaw') {
      const couponIds = value ? value.toString().split(',') : [];
      if (!isEmpty(couponIds)) {
        othersFilters = {
          ...othersFilters,
          couponIds,
        };
      }
      return;
    }

    // Convert pipe separator to comma for payment provider before sending to backend
    // (paymentProvider uses pipe to avoid conflicts with commas in provider IDs, ex: "mercadopago,1234")
    if (value !== '' && key === paymentProviderFilter) {
      const convertedValue = value
        .toString()
        .replace(new RegExp(`\\${PIPE_SEPARATOR}`, 'g'), COMMA_SEPARATOR);
      othersFilters = { ...othersFilters, [key]: convertedValue };
      return;
    }

    if (value !== '') {
      othersFilters = { ...othersFilters, [key]: value };
    }
  });
  const othersFiltersWithPage = {
    ...othersFilters,
    page: `${othersFilters.page}`,
    perPage: ORDERS_PER_PAGE.toString(), // Don't allow modifying the amount per page currently
  };
  if (isEmpty(metafieldsFilters)) {
    return othersFiltersWithPage;
  }
  return {
    ...othersFiltersWithPage,
    metafields: Object.entries(metafieldsFilters),
  };
}
